const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "17%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "9%"
  },
  {
    key: "exhaustPressure",
    zh: "排气压力(MPa)",
    en: "Exhaust Pressure(MPa)",
    width: "10%",
    tooltip: true
  },
  {
    key: "exhaustTemperature",
    zh: "排气温度(℃)",
    en: "Exhaust Temperature(℃)",
    width: "10%",
    tooltip: true
  },
  {
    key: "frequency",
    zh: "频率(Hz)",
    en: "Frequency(Hz)",
    width: "10%",
    tooltip: true
  },
  {
    key: "upperLimitFrequency",
    zh: "上限频率(Hz)",
    en: "Upper Limit Frequency(Hz)",
    width: "10%",
    tooltip: true
  },
  {
    key: "mainSpeed",
    zh: "主机转速(%)",
    en: "Main Speed(%)",
    width: "10%",
    tooltip: true
  },
  {
    key: "percentage",
    zh: "占比",
    en: "Percentage",
    width: "10%"
  }
]

export default columns